<template>
    <div>
        <s-header :name="'食品溯源'"></s-header>
        <van-tabs v-model:active="active" @click-tab="onClickTab">
            <van-tab title="产品信息">
                <div class="topImg"></div>
                <div class="top">
                    <span>{{ info && info.goods && info.goods.name }} {{ info && info.goods && info.goods.spec }}</span>
                    <span class="iconfont icon-anquanyupinzhizhuisu" style="color: #085C92; font-size: 30px"></span>
                </div>
                <div class="table-box">
                    <van-cell-group border>
                        <van-cell title="产品ID" :value="info && info.goods && info.goods.id" />
                        <van-cell title="产品名称" :value="info && info.goods && info.goods.name" />
                        <van-cell title="品牌" :value="info && info.goods && info.goods.product_brand" />
                        <van-cell title="执行标准" :value="info && info.goods && info.goods.standards" />
                        <van-cell title="产品介绍" :value="info && info.introduce" />
                        <van-cell title="条形码" :value="info && info.goods && info.goods.barcode" />
                        <van-cell title="联系方式" :value="info && info.remark" />
                        <van-cell title="许可证编号" :value="info && info.licence_no" />
                        <van-cell title="销售区域" :value="info && info.sales_area" />
                        <van-cell title="产品分类"
                            :value="info && info.goods && info.goods.category && info.goods.category.name" />
                        <van-cell title="净含量" :value="info && info.net_content" />
                        <van-cell title="保质期"
                            :value="info && info.goods && info.goods.shelf_life_days && (info.goods.shelf_life_days + (info.goods.period_unit === '月' ? '个月' : info.goods.period_unit))" />
                        <van-cell title="贮存条件" :value="info && info.hoarding" />
                        <van-cell title="生产企业" :value="info && info.commpany" />
                        <van-cell title="生产企业地址" :value="info && info.adreess" />
                        <van-cell title="委托商" :value="info && info.entrust_company" />
                        <van-cell title="委托商地址" :value="info && info.entrust_address" />
                        <van-cell title="委托商联系方式" :value="info && info.entrust_contact" />
                        <van-cell title="配料表" :value="info && info.ingredients" />

                        <!--                      <van-cell title="其他信息">-->
                        <!--                        <template #right-icon>-->
                        <!--                          <img :src="info && info.goods.images && info.goods.images[0]" alt="外检报告图片" style="width:60%;height:auto;"/>-->
                        <!--                        </template>-->
                        <!--                      </van-cell>-->

                        <van-cell title="其他信息">
                            <div v-if="info && Array.isArray(info.goods.images) && info.goods.images.length > 0"
                                class="image-container">
                                <template v-for="(image, index) in info.goods.images" :key="index">
                                    <img v-if="isImage(image)" :src="image" alt="外检报告图片" class="report-image" @click="onShow(image)" />
                                    <a v-else :href="image" target="_blank" :download="getFileName(image)"
                                        style="display:inline-block;margin:4px;padding:4px 8px;background:#f0f0f0;border-radius:4px;font-size:12px;color:#333;text-decoration:none;">
                                        📄 {{ getFileName(image) }}
                                    </a>
                                </template>
                            </div>
                        </van-cell>

                    </van-cell-group>
                </div>
            </van-tab>
            <van-tab title="追溯信息">
                <p class="dataWrap" @click="onClick">
                    <van-icon name="search" style="margin-right: 12px" />
                    <span v-if="!value">请选择生产日期</span>
                    <span style="color: #333" v-else>{{ value }}</span>
                    <van-icon @click.stop="defaultData" style="float: right; margin-top: 3px" name="cross" />
                </p>
                <div class="searchOn batchSection" v-if="batchList && batchList.length">
                    <p class="top1">快捷查询批次</p>
                    <div class="batchScroll" ref="batchScrollRef" @wheel.prevent="handleBatchWheel">
                        <span v-for="(val, index) in batchList" :key="index" @click="onBatch(val.batch, index)" :class="noIndex === index ? 'clickActive' : ''">{{ val.batch }}</span>
                    </div>
                </div>
                <div class="searchOn">
                    <p class="top1">配料编号</p>
                    <p class="list1">
                        <span v-for="(val, index) in numberList" :key="index" @click="onBatch1(val, index)"
                            :class="noIndex1 === index ? 'clickActive' : ''">{{ val }}</span>
                    </p>
                </div>
                <div class="table-box">
                    <van-cell-group border>
                        <!-- <van-cell title="配料编号" :value="batchInfo && batchInfo.formulas_number" /> -->
                        <van-cell title="批次" :value="batchInfo && batchInfo.batch" />
                        <van-cell title="生产日期" :value="batchInfo && batchInfo.date" />
                        <van-cell title="保质期至" :value="batchInfo && batchInfo.period" />
                    </van-cell-group>
                </div>
                <!-- <van-search @click="onClick" v-model="value" placeholder="请选择生产日期" /> -->
                <van-popup :show="showPop" position="bottom" label="有效日期"
                    custom-style="height: 50%; border: 1px solid #ccc" @close="onCancel">
                    <van-date-picker @cancel="onCancel" @confirm="onConfirm" v-model="currentDate" title="选择日期"
                        :min-date="minDate" :max-date="maxDate" />
                </van-popup>
                <div class="list">
                    <van-steps direction="vertical" :active="stepList && stepList.length">
                        <van-step v-for="(val, index) in stepList" :key="index">
                            <template #inactive-icon>
                                <span class="iconfont" :class="val.icon || 'icon-yanshou'"></span>
                            </template>
                            <template #active-icon>
                                <span class="iconfont icon-anquanyupinzhizhuisu"></span>
                            </template>
                            <p class="title">{{ val.title }}</p>
                            <div style="display: flex;justify-content: space-between">
                                <div>
                                    <span v-if="val.describe_y || val.describe_s"
                                        style="display: inline-block; padding-bottom: 10px; border-bottom: 1px solid #ccc">
                                        <span v-if="index === 0">
                                            <span class="tip" v-for="(node, index1) in val.describe_y" :key="index1">
                                                {{ node }}
                                            </span>
                                        </span>
                                        <span v-if="index === 1">
                                            <span class="tip" v-for="(node, index1) in val.describe_s" :key="index1">
                                                {{ node }}
                                            </span>
                                        </span>
                                    </span>
                                    <span v-else>
                                        <span class="tip" v-for="(node, index1) in val.result" :key="index1">
                                            {{ node }}
                                        </span>
                                    </span>
                                    <div v-if="index === 0">
                                        <div v-for="(node, index2) in val.record && val.record.material" :key="index2"
                                            style="padding-bottom: 10px; border-bottom: 1px solid #ccc">
                                            <p>原辅料名称 {{ node.product_name }}</p>
                                            <p>原材料批次 {{ node.material_batch }}</p>
                                            <span style="vertical-align: middle">检验报告 </span>
                                            <template v-for="(img, imgIndex) in node.report_img" :key="imgIndex">
                                                <img v-if="isImage((img.url) || img)"
                                                    style="width: 80px; height: 80px; object-fit: cover;"
                                                    :src="(img.url) || img" @click="onShow((img.url) || img)" />
                                                <a v-else
                                                    :href="(img.url) || img"
                                                    target="_blank"
                                                    style="display:inline-block;margin:4px;padding:4px 8px;background:#f0f0f0;border-radius:4px;font-size:12px;color:#333;text-decoration:none;">
                                                    📄 {{ getFileName((img.url) || img) }}
                                                </a>
                                            </template>
                                        </div>
                                    </div>
                                    <div v-if="index === 1">
                                        <p>投料时间 {{ val.record && val.record.start ? (val.record.start.split('T')[0] + ' ' + val.record.start.split('T')[1]) : '-' }}</p>
                                        <p>投料人 {{ (val.record && val.record.recorder) ? val.record.recorder : '-' }}</p>
                                        <p>复核人 {{ (val.record && val.record.reviewer) ? val.record.reviewer : '-' }}</p>
                                        <p>投料情况 {{ (val.record && val.record.situation) ? val.record.situation : '-' }}</p>
                                    </div>
                                    <template v-for="(item, count) in (Array.isArray(val.image) ? val.image : (val.image ? [val.image] : []))" :key="count">
                                        <img v-if="isImage((item && item.response) ? (item.response.data && item.response.data.file_url) : item)"
                                            style="width: 80px; height: 80px; object-fit: cover; margin: 4px;"
                                            :src="(item && item.response) ? (item.response.data && item.response.data.file_url) : item"
                                            @click="onShow((item && item.response) ? (item.response.data && item.response.data.file_url) : item)" />
                                        <a v-else
                                            :href="(item && item.response) ? (item.response.data && item.response.data.file_url) : item"
                                            target="_blank"
                                            :download="getFileName((item && item.response) ? (item.response.data && item.response.data.file_url) : item)"
                                            style="display:inline-block;margin:4px;padding:4px 8px;background:#f0f0f0;border-radius:4px;font-size:12px;color:#333;text-decoration:none;">
                                            📄 {{ getFileName((item && item.response) ? (item.response.data && item.response.data.file_url) : item) }}
                                        </a>
                                    </template>
                                </div>
                                <!-- <p>
                                    <span v-for="(item, count) in val.image" :key="count" @click="showPopup(item)" style="margin-right: 10px">查看</span>
                                </p> -->
                            </div>
                        </van-step>
                    </van-steps>
                </div>
                <!-- <van-popup closeable v-model:show="show" :style="{ width: '80%' }">
                    <img style="width: 100%;" :src="imgSrc" />
                </van-popup> -->
            </van-tab>
            <van-tab title="企业信息">
                <div class="table-box">
                    <van-cell-group border>
                        <van-cell title="企业名称" :value="info1 && info1.title" />
                        <van-cell title="企业地址" :value="info1 && info1.address_name" />
                        <van-cell title="联系电话" :value="info1 && info1.mobile" />
                        <van-cell title="资质证书" center>
                            <template #right-icon>
                                <div style="display: flex; flex-direction: column">
                                    <img style="width: 80%; margin-bottom: 20px"
                                        v-for="(val, index) in info1 && info1.credential && info1.credential.certificate"
                                        :key="index" :src="val" @click="onShow(val)" />
                                </div>
                            </template>
                        </van-cell>
                        <van-cell title="许可范围" :value="info1 && info1.credential && info1.credential.scope" />
                    </van-cell-group>
                </div>
            </van-tab>
                    <van-tab title="生产视频">
                <div class="table-box">
                    <van-cell-group border>
                        <!-- 当没有视频URL时显示提示信息 -->
                        <div v-if="videoStreamUrls.length === 0" class="no-video-tip">
                            <van-icon name="info-o" size="24" color="#999" />
                            <p>该企业还未接入阳光工厂项目</p>
                        </div>
                        <!-- 有视频URL时显示视频播放器 -->
                        <div 
                            v-for="(url, index) in videoStreamUrls" 
                            :key="index" 
                            class="full-width-video"
                        >
                            <div class="video-header">
                                <span class="video-title">生产线{{ index + 1 }}</span>
                                <span class="video-status" :class="getStatusClass(videoStatuses[index])">
                                    {{ videoStatuses[index] }}
                                </span>
                            </div>
                            <stream-player
                                :src="url"
                                :width="'100vw'"
                                :height="200"
                                :controls="true"
                                :autoplay="true"
                                :muted="true"
                                :show-protocol-info="true"
                                @loadstart="(event) => onVideoLoadStart(event, index)"
                                @canplay="(event) => onVideoCanPlay(event, index)"
                                @error="(event) => onVideoError(event, index)"
                                @protocol-detected="(protocol) => onProtocolDetected(protocol, index)"
                            />
                        </div>
                    </van-cell-group>
                </div>
            </van-tab>
        </van-tabs>
        <van-popup v-model:show="isShow">
            <img style="width: 100%" :src="imgInfo" />
        </van-popup>
        <van-icon v-show="isShow" @click="isShow = false" class="crossIcon" name="cross" />
    </div>
</template>

<script>
import sHeader from '@/components/SimpleHeader'
import StreamPlayer from '@/components/StreamPlayer.vue'
import { reactive, onMounted, toRefs, ref } from 'vue'
import { getDetails, getList, getInfo, getBatch } from '@/service/trace'
import { QVideoStreamApi } from '@/service/viode'
import { showToast } from 'vant'
export default {
    name: "Trace",
    components: {
            sHeader,
            StreamPlayer
        },
    setup() {
        const isShow = ref(false);
        const imgInfo = ref('')
        const batchList = ref([])
        const numberList = ref([])
        const batchScrollRef = ref(null)


        // 已不再使用本地企业/通道配置，改为邀请接口返回的 m3u8 地址

        // 调用邀请接口并按channel替换URL中的流ID
        // 根据 productId 获取设备通道并邀请播放，返回 m3u8 播放地址数组
        async function inviteAndUpdate(productId) {
                const data1 = await QVideoStreamApi({
                        product_id: productId
                    })
             const json2 = await data1
       

            try {
                let  id =  json2 && json2.data && json2.data.channel
                const payload = {
                    media_server_id: 4,
                    device_id: id,
                    channel_id: id,
                    sub_stream: 0,
                    play_type: 0,
                    start_time: 0,
                    end_time: 0
                }
                const resp = await fetch('https://vidio.tvtvc.com/srs-sip/v1/invite', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json, text/plain, */*'
                    },
                    body: JSON.stringify(payload)
                })
                const json = await resp.json()
                if (json && json.code === 0 && json.data && json.data.url && json.data.channel_id) {
                    const channelId = json.data.channel_id
                    const streamId = String(json.data.url).split('/').pop()
                    console.log('邀请接口返回：', { channelId, streamId, url: json.data.url })
                    // 直接生成 m3u8 播放地址，不再依赖本地公司/通道配置
                    const base = 'https://flvsp.vdvq.com/live/'
                    const hlsUrl = `${base}${streamId}.m3u8`
                    return [hlsUrl]
                } else {
                    console.warn('邀请接口返回异常：', json)
                    return []
                }
            } catch (e) {
                console.error('邀请接口调用失败：', e)
                return []
            }
        }
 
            
    
        const videoStreamUrls = ref([])
        const videoStatuses = ref([])
        const active = ref(0);
        const currentDate = ref(['2021', '01', '01']);
        const showPop = ref(false);
        const value = ref('');
        const value1 = ref('');
        const info = ref(null);
        const info1 = ref(null);
        const id = ref('');
        const infoPici = ref({});
        // const show = ref(false);
        // const imgSrc = ref('')
        const defaultStepList = [
            {
                title: '原料验收',
                result: ['原料索证齐全', '原料验收合格'],
                icon: 'icon-yanshou',
                image: []
            },
            {
                title: '生产投料',
                result: ['根据订单生产'],
                icon: 'icon-shengchanlingliao',
                image: []
            },
            {
                title: '半成品检测',
                result: ['半成品检测合格'],
                icon: 'icon-jiance',
                image: []
            },
            {
                title: '成品检测',
                result: ['成品检测合格'],
                icon: 'icon-jiance',
                image: []
            },
            {
                title: '成品出库',
                result: ['成品出库检测合格'],
                icon: 'icon-ruku',
                image: []
            }
        ]
        const state = reactive({
            currentDate,
            minDate: new Date(2020, 0, 1),
            maxDate: new Date(2035, 5, 1),
            stepList: defaultStepList.map(s => ({ ...s })),
            batchInfo: {},
            noIndex: null,
            noIndex1: 0
        })
        onMounted(async () => {
            var url = window.location.href;
            var dz_url = url.includes('?') ? url.split('?')[1].split('=')[1] : '1';
            id.value = dz_url;
            const { data } = await getDetails({ product_id: dz_url })
             info.value = data;
            // 预加载追溯信息（避免点击 tab 时因 active.value 时序问题未触发）
            getBatchInfo('')
            // 检测iOS设备
            const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
            console.log('设备检测结果:', {
                userAgent: navigator.userAgent,
                isIOS: isIOS,
                company: data.commpany
            })
            try{
           const res = await getInfo({ product_id: dz_url })
                info1.value = res.data
            }catch(e){
                console.error('获取视频流接口调用失败：', e)
            }
            try{
            const res1 = await getBatch({ product_id: dz_url })
            batchList.value = (res1.data && res1.data.pici || [])
            // 用最早批次日期动态设置日期选择器 minDate
            if (batchList.value.length > 0) {
                const earliest = batchList.value[batchList.value.length - 1].batch
                if (earliest && earliest.length === 8) {
                    const y = parseInt(earliest.slice(0, 4))
                    const m = parseInt(earliest.slice(4, 6)) - 1
                    const d = parseInt(earliest.slice(6, 8))
                    state.minDate = new Date(y, m, d)
                }
            }
            }catch(e){
                console.error('获取批次接口调用失败：', e)
            }

            let urls =  []
            try{
                  urls = await inviteAndUpdate(dz_url)
            }catch(e){
                console.error('邀请接口调用失败：', e)
                return []
            }
            // 基于邀请返回的 streamId 直接构造 m3u8 播放地址

            videoStreamUrls.value = urls
            // 初始化视频状态数组，长度与视频URL数组匹配
            videoStatuses.value = new Array(videoStreamUrls.value.length).fill('未连接')
            console.log('初始化视频数量:', videoStreamUrls.value.length)
        })
        function onClickTab(tab) {
            if ((tab && tab.name == 1) || active.value == 1) {
                getBatchInfo(value1.value, true)
            }
        }
        async function getBatchInfo(val, showAlert = false) {
            let res
            try {
                res = await getList({ product_id: id.value, date: val })
            } catch (e) {
                console.error('QTraceabilityApi error:', e)
                if (showAlert) {
                    showToast({ icon: 'warning-o', className: 'trace-warn-toast' })
                }
                return
            }
            const msg = res.message || {}
            const dataMap = res.data || {}
            let nowStr = (msg.formulas_number && msg.formulas_number[0]) || Object.keys(dataMap)[0]
            numberList.value = msg.formulas_number || []
            const rawSteps = (nowStr && dataMap[nowStr]) || []

            // 智能合并：始终显示完整的 5 个步骤框架，用 API 数据填充已有步骤
            const mergedSteps = defaultStepList.map(defaultStep => {
                // 按 title 匹配 API 返回的步骤
                const apiStep = rawSteps.find(s => s.title === defaultStep.title)
                if (apiStep) {
                    // 如果 API 有返回该步骤，使用 API 数据
                    return apiStep
                } else {
                    // 如果 API 没有返回该步骤，使用默认占位（深拷贝避免共享引用）
                    return { ...defaultStep, result: ['待填写'] }
                }
            })
            state.stepList = mergedSteps
            infoPici.value = dataMap
            state.batchInfo = msg
            // 自动回填显示日期（仅首次加载，val 为空时）
            if (!val && !value.value && msg.batch) {
                const b = String(msg.batch)
                if (b.length === 8) {
                    value.value = b.slice(0, 4) + '-' + b.slice(4, 6) + '-' + b.slice(6, 8)
                } else {
                    value.value = b
                }
            }
        }
        function onBatch(val, index) {
            // 同步更新日期显示字段
            if (val && val.length === 8) {
                value.value = val.slice(0, 4) + '-' + val.slice(4, 6) + '-' + val.slice(6, 8)
                value1.value = val
            }
            // 清除配料编号选中状态，重置为第一个
            state.noIndex1 = 0
            getBatchInfo(val)
            state.noIndex = index
        }
        function handleBatchWheel(e) {
            // 鼠标滚轮横向滚动：将纵向滚动转换为横向滚动
            const el = batchScrollRef.value
            if (el) {
                el.scrollLeft += e.deltaY
            }
        }
        async function onBatch1(val, index) {
            state.noIndex1 = index
            state.stepList = infoPici.value[val] || []
        }
        function isPDF(link) {
            return link.toLowerCase().endsWith('.pdf');
        }
        function isImage(link) {
            if (!link) return false;
            return /\.(jpg|jpeg|png|gif|webp|bmp|svg)(\?.*)?$/i.test(link);
        }
        function getFileName(link) {
            if (!link) return '文件';
            return decodeURIComponent(link.split('/').pop().split('?')[0]) || '文件';
        }
        function onShow(val) {
            imgInfo.value = val
            isShow.value = true
        }
        function onClick() {
            showPop.value = true
        }
        async function defaultData() {
            if (value.value) {
                value.value = ''
                value1.value = ''
                await getBatchInfo('')
            }
        }
        function onCancel() {
            showPop.value = false
        }
        async function onConfirm(val) {
            showPop.value = false
            state.noIndex = null
            value.value = val.selectedValues.join('-')
            value1.value = val.selectedValues.join('')
            try {
                const res = await getList({ product_id: id.value, date: val.selectedValues.join('') })
                let nowStr = res.message.formulas_number && res.message.formulas_number[0]
                numberList.value = res.message && res.message.formulas_number
                const rawSteps = (nowStr && res.data[nowStr]) || []

                // 智能合并：始终显示完整的 5 个步骤框架，用 API 数据填充已有步骤
                const mergedSteps = defaultStepList.map(defaultStep => {
                    const apiStep = rawSteps.find(s => s.title === defaultStep.title)
                    if (apiStep) {
                        return apiStep
                    } else {
                        return { ...defaultStep, result: ['待填写'] }
                    }
                })
                state.stepList = mergedSteps
                infoPici.value = res.data
                state.batchInfo = res.message
            } catch (e) {
                console.error('日期选择后获取数据失败：', e)
                showToast('获取数据失败，请重试')
            }
        }
        /* function showPopup(item) {
            show.value = true;
            imgSrc.value = item;
        } */
        
        // 视频播放器事件处理
        function onVideoLoadStart(event, index) {
            videoStatuses.value[index] = '正在加载...'
            console.log(`视频${index + 1}开始加载`)
        }
        
        function onVideoCanPlay(event, index) {
            videoStatuses.value[index] = '已连接'
            console.log(`视频${index + 1}可以播放`)
        }
        
        function onVideoError(error, index) {
            // 遇到错误时先显示缓冲效果的状态提示
            videoStatuses.value[index] = '缓冲中，5秒后重试...'
            console.error(`视频${index + 1}播放错误详情:`, {
                url: videoStreamUrls.value[index],
                error: error,
                timestamp: new Date().toISOString(),
                protocol: error.protocol,
                errorType: error.errorType,
                errorDetail: error.errorDetail
            })
            
            // 检查是否是M3U8相关错误
            const url = videoStreamUrls.value[index]
            const isM3U8 = url && url.includes('.m3u8')
            
            console.log(`视频${index + 1}错误分析:`, {
                isM3U8: isM3U8,
                url: url,
                errorProtocol: error.protocol
            })
            
            // 显示更友好的错误提示
            if (error.protocol === 'hls' && isM3U8) {
                // HLS网络错误已在子组件中切换为缓冲并自动重试，这里只更新状态文案
                videoStatuses.value[index] = '缓冲中，5秒后重试...'
                console.error(`M3U8播放失败或网络问题，已自动进入重试: ${url}`)
            } else if (error.errorType === 'NetworkError') {
                videoStatuses.value[index] = '网络连接失败，自动重试中...'
            } else if (error.errorType === 'MediaError') {
                videoStatuses.value[index] = '媒体格式错误，请检查流格式'
            } else {
                videoStatuses.value[index] = '播放失败，自动重试中...'
            }
        }
        
        function onProtocolDetected(protocol, index) {
            console.log(`视频${index + 1}检测到协议:`, protocol)
            videoStatuses.value[index] = `已连接 (${protocol})`
        }
        
        function getStatusClass(status) {
            if (!status || typeof status !== 'string') {
                return 'status-disconnected'
            }
            if (status.includes('已连接')) {
                return 'status-connected'
            } else if (status.includes('正在加载')) {
                return 'status-loading'
            } else if (status.includes('失败') || status.includes('错误')) {
                return 'status-error'
            } else {
                return 'status-disconnected'
            }
        }
        return {
            active,
            onBatch,
            onClickTab,
            onClick,
            showPop,
            onBatch1,
            batchList,
            numberList,
            infoPici,
            onShow,
            imgInfo,
            onCancel,
            onConfirm,
            getBatchInfo,
            defaultData,
            value,
            value1,
            info,
            info1,
            id,
            isPDF,
            isImage,
            getFileName,
            // show,
            isShow,
            // showPopup,
            // imgSrc,
            videoStreamUrls,
            videoStatuses,
            onVideoLoadStart,
            onVideoCanPlay,
            onVideoError,
            onProtocolDetected,
            getStatusClass,
            batchScrollRef,
            handleBatchWheel,
            ...toRefs(state),
        }
    }
}
</script>

<style scoped lang="less">
.dataWrap {
    font-size: 16px;
    padding: 8px 20px;
    margin: 20px;
    border: 2px solid #e05304;
    color: #ddd;
}

.searchOn {
    margin: 20px;
    color: #666;

    .top1 {
        font-weight: bold;
        color: #333;
        font-size: 16px;
    }

    .list1 {
        display: flex;
        flex-wrap: wrap;

        span {
            display: inline-block;
            width: 30%;
            margin-right: 2%;
            text-align: center;
            border: 1px solid #ddd;
            padding: 8px 0;
            background: #F7F7F7;
            border-radius: 5px;
            margin-bottom: 10px;
        }

        span.clickActive {
            color: #1989fa;
            border-color: #1989fa;
        }
    }
}

.batchSection {
    .batchScroll {
        display: flex;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        padding-bottom: 6px;
        gap: 8px;

        &::-webkit-scrollbar {
            height: 3px;
        }
        &::-webkit-scrollbar-thumb {
            background: #ddd;
            border-radius: 3px;
        }

        span {
            flex-shrink: 0;
            display: inline-block;
            padding: 6px 14px;
            border: 1px solid #ddd;
            background: #F7F7F7;
            border-radius: 16px;
            font-size: 14px;
            color: #555;
            white-space: nowrap;
            cursor: pointer;

            &.clickActive {
                color: #1989fa;
                border-color: #1989fa;
                background: #e6f4ff;
            }
        }
    }
}

.crossIcon {
    position: fixed;
    z-index: 99999;
    font-size: 20px;
    top: 60px;
    color: #fff;
    right: 10px;
}

::v-deep .van-cell__title {
    flex: none;
    width: 30%;
}

::v-deep .van-search__content {
    border: 3px solid #E05304;
}

::v-deep .van-step--finish .van-step__circle,
::v-deep .van-step--finish .van-step__line {
    background: #ccc;
}

.topImg {
    margin-top: 20px;
    height: 100px;
    background: url("~@/assets/bg.png") no-repeat center;
    background-size: cover;
}

.top {
    display: flex;
    margin: 0 20px;
    font-size: 20px;
    font-weight: bold;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    color: #D45510;
}

.info {
    height: 40px;
    line-height: 40px;
    margin: 0 0 12px;
    background: #E05304;
    color: #fff;
    padding-left: 20px;
    font-size: 16px;
}

.table-box {
    margin-bottom: 12px;

    ::v-deep .van-cell__value {
        text-align: left;
    }
}

::v-deep .van-steps {
    padding-left: 60px;
}

.list {
    margin-bottom: 30px;

    .title {
        padding: 6px 10px;
        font-size: 16px;
        margin-top: 0;
        color: #1989fa;
    }

    .tip {
        font-size: 14px;
        color: #333;
        margin-right: 20px;
    }
}

.iconfont {
    color: #fff;
    display: inline-block;
    font-size: 16px;
    padding: 8px;
    background: #0FBDD1;
    border-radius: 50%;
}

.image-container {
    width: 95%;
}

.report-image {
    width: 95%;
}

.full-width-video {
    width: 100vw;
    margin: 0;
    padding: 0;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
}

.video-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    background: #f5f5f5;
    border-bottom: 1px solid #e0e0e0;
}

.video-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
}

.video-status {
    font-size: 14px;
    padding: 4px 8px;
    border-radius: 12px;
    font-weight: 500;
}

.status-connected {
    background: #e8f5e8;
    color: #52c41a;
    border: 1px solid #b7eb8f;
}

.status-loading {
    background: #e6f7ff;
    color: #1890ff;
    border: 1px solid #91d5ff;
}

.status-error {
    background: #fff2f0;
    color: #ff4d4f;
    border: 1px solid #ffccc7;
}

.status-disconnected {
    background: #f5f5f5;
    color: #999;
    border: 1px solid #d9d9d9;
}

.video-container {
    width: 100%;
    max-width: 400px;
    margin: 10px 0;
}

.no-video-tip {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    text-align: center;
    color: #999;
}

.no-video-tip p {
    margin: 10px 0 0 0;
    font-size: 16px;
    color: #666;
}

::v-deep .van-field__control {
    font-size: 12px;
}

::v-deep .van-cell__right-icon {
    width: 100%;
    max-width: 400px;
}
</style>

<style>
.trace-warn-toast {
    background: transparent !important;
    box-shadow: none !important;
}
.trace-warn-toast .van-icon {
    color: #333 !important;
    font-size: 40px !important;
}
</style>
